import { SelectHTMLElement } from "components/input/baseHTMLElementInput";
import { Optgroup, Option } from "components/input/select/options";

export abstract class BaseSelectHTMLHTMLElement extends SelectHTMLElement {

    private _options: Array<Option | Optgroup> = [];
    private _codeInOptionLabel: boolean = null;

    public set options(options: Array<Option | Optgroup>) {
        this._options = options;
    }

    public get options() {
        return this._options;
    }

    public set codeInOptionLabel(codeInOptionLabel: boolean) {
        this._codeInOptionLabel = codeInOptionLabel;
    }

    public get codeInOptionLabel() {
        return this._codeInOptionLabel;
    }

    public bindEvents(): void {
        this.genericBindEvents();
    }
    
    public setOptions(options: Array<Option | Optgroup>): void {
        this.input.innerHTML = "";
        this.options.length = 0;
        this.addOptions(options);
    }

    public abstract addOptions(options: Array<Option | Optgroup>): void;
    
    public enableOptions(options: Array<string | number>) {
        this.enableDisableOptions(options, false);
    }

    public enableDisableOptions(options: Array<string | number>, disabled: boolean) {
        for (const optionValue of options ?? []) {
            (this.input.querySelector("option[value=" + optionValue + "]") as HTMLOptionElement).disabled = disabled;
        }
    }

}
